import {deleteOfferTemplate} from "@project/sdk/sales";
import {DeleteOfferTemplateResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {offerTemplateKeys, offerTemplateMutationKeys} from "../../../offerTemplate-keys";

export function deleteOfferTemplateMutationOptions() {
  return mutationOptions({
    mutationKey: offerTemplateMutationKeys.deleteOfferTemplate,
    mutationFn: async (id: string) =>
      DeleteOfferTemplateResponse.parse(await deleteOfferTemplate(id)),
    onSuccess: async (_result, ownerId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: offerTemplateKeys.detail(ownerId)}),
        client.invalidateQueries({queryKey: offerTemplateKeys.lists()}),
      ]);
    },
  });
}
